export default {"src":"/_next/static/media/Zen CORE.8e40a4c2.svg","height":312,"width":313,"blurWidth":0,"blurHeight":0};